export const prepareDataForCBROdds = (data) => {
    let preparedData = [];
    data.map((item) => {
        item.recommendations.map((rec) => {
            preparedData.push({
                uof: item.uof,
                items: rec.items.map((itemRec) => ({
                    selectionInfo: {
                        ...itemRec.selectionInfo,
                    },
                })),
            });
        });
    });
    return { recommendations: preparedData };
};

export const getVaixData = (recommendation) => {
    let outcomeData = [];
    let vaixEventId = '';
    let vaixExternalEventId = '';
    let clearArray = new Set();
    let valueToCheck = 'sr:match:';
    let concatedEvents = [];
    let selections = [];

    recommendation.items.map((item) => {
        outcomeData = [...outcomeData, ...item?.outcome?.mtsRef.split('|')];
        selections.push({
            id: item?.selectionInfo?.selectionId || 0,
            event_id: item?.outcome?.mtsRef.split('|')[0],
        });
        concatedEvents.push(
            `CUSTOM_BET_${item.market.marketId}_${
                item.outcome.betNr
            }_${item.market.marketName.replace(/\s/g, '')}`
        );
    });

    outcomeData.map((item) => clearArray.add(item));
    clearArray.forEach((item) => {
        item.includes(valueToCheck)
            ? (vaixEventId = item)
            : (vaixExternalEventId += `${item};`);
    });

    return {
        vaixEventId,
        vaixExternalEventId,
        concatedEvents,
        selections,
    };
};

export const getOddsForBetRecommendations = (recommendations, odds) => {
    const recCopy = [...recommendations];
    recommendations.forEach((item, index) => {
        odds.forEach((recWithOdds) => {
            if (item.uof === recWithOdds.uof) {
                item.recommendations.forEach((recItem, recIndex) => {
                    const arrayOfSelectionsRec = recItem.items.map(
                        (itemRec) => itemRec.selectionInfo.selectionId
                    );
                    const arrayOfSelectionsOdds = recWithOdds.items.map(
                        (items) => items.selectionInfo.selectionId
                    );
                    if (
                        arrayOfSelectionsRec.length ===
                            arrayOfSelectionsOdds.length &&
                        arrayOfSelectionsRec.every((selectionId) =>
                            arrayOfSelectionsOdds.includes(selectionId)
                        )
                    ) {
                        recCopy[index].recommendations[recIndex].totalOdds =
                            recWithOdds.totalOdds;
                    }
                });
            }
        });
    });
    return recCopy;
};
